/**
 * Normalize a CMS-stored productSlug into the canonical URL slug.
 *
 * Some Strapi entries store the full path (`/products/opc-cement`) instead of
 * just the slug (`opc-cement`). Kept in a client-safe module so URL helpers
 * and client components can use it without importing server-only Strapi code.
 */
export function normalizeProductSlug(raw: string | null | undefined): string {
  if (!raw) return '';
  return raw.replace(/^\/+(products\/)?/, '');
}
